import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface SupplierKycData {
	supplierKycId: string;
	supplierKycMobile: string;
	supplierKycLanguage?: string;
	userLanguage: LanguageData;
}

interface LanguageData {
	langCode: string;
	langId: number;
}

interface PersonaState {
	userSelectedPersona: string | null;
	supplierKycData: SupplierKycData | null;
	setUserPersona: (persona: string) => void;
	setSupplierKycData: (data: SupplierKycData) => void;
}

export const usePersonaStore = create<PersonaState>()(
	devtools(
		set => ({
			userSelectedPersona: null,
			supplierKycData: null,
			setUserPersona: (persona: string) => set({ userSelectedPersona: persona }),
			setSupplierKycData: (data: SupplierKycData) =>
				set({ supplierKycData: data }),
		}),
		{ name: 'persona-store' },
	),
);
